module.exports = __webpack_public_path__ + "img/icon_4.a64bcee9.svg";